import React from "react";

class PortalHeader extends React.Component {
    render() {
        return (
            <>
                <nav className="side-nav">
                    <a href="/portal/home" className="intro-x flex items-center pl-5 pt-4">
                        <span className="hidden xl:block text-white text-lg ml-3"> U<span className="font-medium">Short</span> </span>
                    </a>
                    <div className="side-nav__devider my-6"></div>
                    <ul>
                        <li>
                            <a href="/portal/home" className="side-menu dashboard">
                                <div className="side-menu__icon"> <i data-feather="home"></i> </div>
                                <div className="side-menu__title"> Dashboard </div>
                            </a>
                        </li>
                        <li>
                            <a href="#/" className="side-menu short_url">
                                <div className="side-menu__icon"> <i data-feather="link"></i> </div>
                                <div className="side-menu__title"> Short URLs <i data-feather="chevron-down" className="side-menu__sub-icon"></i> </div>
                            </a>
                            <ul className="">
                                <li>
                                    <a href="/portal/url/create" className="side-menu">
                                        <div className="side-menu__icon"> <i data-feather="link"></i> </div>
                                        <div className="side-menu__title"> Create Short URL </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="/portal/url/track" className="side-menu">
                                        <div className="side-menu__icon"> <i data-feather="activity"></i> </div>
                                        <div className="side-menu__title"> Track URL </div>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="/portal/analytics" className="side-menu analytics">
                                <div className="side-menu__icon"> <i data-feather="bar-chart"></i> </div>
                                <div className="side-menu__title"> Analytics </div>
                            </a>
                        </li>
                    </ul>
                </nav>

            </>
        );
    }
}

export default PortalHeader;